<div class="bn">
  <header class="bn-cabecalho">
    <div>
      <h4 class="page-title bn-titulo"><i class="fas fa-images"></i> Banners</h4>
      <p class="bn-subtitulo">Promoções e destaques que passam no topo do cardápio, na ordem desta lista.</p>
    </div>
    <button type="button" class="bn-botao-primario" (click)="novo()">
      <i class="fe-plus"></i> Novo banner
    </button>
  </header>

  <div class="bn-resumo" *ngIf="!carregando && banners.length">
    <span><b>{{ banners.length }}</b> {{ banners.length === 1 ? 'banner' : 'banners' }}</span>
    <span class="bn-resumo-ponto"></span>
    <span><b>{{ totalAtivos() }}</b> no ar</span>
    <ng-container *ngIf="banners.length - totalAtivos() > 0">
      <span class="bn-resumo-ponto"></span>
      <span class="bn-resumo-vencidos"><b>{{ banners.length - totalAtivos() }}</b> vencido{{ banners.length - totalAtivos() === 1 ? '' : 's' }}</span>
    </ng-container>
  </div>

  <!-- Carregando -->
  <div class="bn-lista" *ngIf="carregando">
    <div class="bn-cartao bn-cartao--esqueleto" *ngFor="let i of [1, 2, 3]">
      <span class="bn-esq bn-esq-ordem"></span>
      <span class="bn-esq bn-esq-imagem"></span>
      <div class="bn-info">
        <span class="bn-esq bn-esq-linha"></span>
        <span class="bn-esq bn-esq-linha curta"></span>
      </div>
    </div>
  </div>

  <!-- Vazio -->
  <div class="bn-vazio" *ngIf="!carregando && !banners.length">
    <div class="bn-vazio-arte">
      <span class="bn-vazio-faixa"></span>
      <span class="bn-vazio-faixa"></span>
      <span class="bn-vazio-faixa"></span>
      <i class="fe-image"></i>
    </div>
    <h5>Nenhum banner ainda</h5>
    <p>Use banners para anunciar promoções, combos da semana ou novidades logo na entrada do cardápio.</p>
    <button type="button" class="bn-botao-primario" (click)="novo()">
      <i class="fe-plus"></i> Criar o primeiro banner
    </button>
  </div>

  <!-- Lista -->
  <div class="bn-lista" *ngIf="!carregando && banners.length">
    <article class="bn-cartao" *ngFor="let banner of banners; let i = index; let ultimo = last"
             [class.is-vencido]="estaVencido(banner)">
      <div class="bn-ordem">
        <button type="button" class="bn-icone" (click)="moverCima(i)" [disabled]="i === 0" title="Subir" aria-label="Subir banner">
          <i class="fe-chevron-up"></i>
        </button>
        <span class="bn-posicao">{{ i + 1 }}</span>
        <button type="button" class="bn-icone" (click)="moverBaixo(i)" [disabled]="ultimo" title="Descer" aria-label="Descer banner">
          <i class="fe-chevron-down"></i>
        </button>
      </div>

      <button type="button" class="bn-imagem" (click)="editar(banner)" [attr.aria-label]="'Editar ' + banner.nome">
        <img *ngIf="banner.linkImagem && !imagemQuebrada[banner.id]" [src]="'/images/empresa/' + banner.linkImagem" alt=""
             loading="lazy" (error)="imagemQuebrada[banner.id] = true">
        <i *ngIf="!banner.linkImagem || imagemQuebrada[banner.id]" class="fe-image"></i>
      </button>

      <div class="bn-info">
        <div class="bn-nome">{{ banner.nome || 'Sem nome' }}</div>
        <div class="bn-etiquetas">
          <span class="bn-etiqueta" [ngSwitch]="banner.comando">
            <ng-container *ngSwitchCase="'LINK'"><i class="fe-external-link"></i> Abre {{ banner.extra }}</ng-container>
            <ng-container *ngSwitchCase="'BUSCA'"><i class="fe-search"></i> Mostra produtos: “{{ banner.extra }}”</ng-container>
            <ng-container *ngSwitchDefault><i class="fe-image"></i> Só exibe a imagem</ng-container>
          </span>
          <span class="bn-etiqueta bn-validade" [ngClass]="'is-' + situacaoValidade(banner)">
            <i class="fe-calendar"></i> {{ textoValidade(banner) }}
          </span>
        </div>
      </div>

      <div class="bn-acoes">
        <button type="button" class="bn-botao" (click)="editar(banner)"><i class="fe-edit-2"></i> Editar</button>
        <button type="button" class="bn-icone bn-icone--perigo" (click)="abraDialogRemover(banner)" title="Remover" aria-label="Remover banner">
          <i class="fe-trash-2"></i>
        </button>
      </div>
    </article>
  </div>
</div>

<kendo-dialog title="Remover banner" *ngIf="modalDeletar" (close)="close('nao')" [minWidth]="250" [width]="420">
  <div class="bn-dialogo">
    <img *ngIf="bannerApagar?.linkImagem" [src]="'/images/empresa/' + bannerApagar.linkImagem" alt="">
    <p>O banner <b>{{ bannerApagar?.nome }}</b> sai do cardápio agora. Essa ação não pode ser desfeita.</p>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="close('nao')" [disabled]="removendo">Cancelar</button>
    <button kendoButton themeColor="error" (click)="close('sim')" [disabled]="removendo">{{ removendo ? 'Removendo...' : 'Remover' }}</button>
  </kendo-dialog-actions>
</kendo-dialog>
